(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('reporting-payment-arrears', {
            parent: 'entity',
            url: '/reporting-payment-arrears?page&sort&searchQuery&agenceId&etat&compteurFerme&portefeuilleContrat&contractType&contractProfil&serviceVendu&startDate&endDate&onlinePaymentActive&onlinePaymentQuery&onlinePaymentType&anyBillSince&dontPaidSince&currentBalanceSigne&currentBalanceValue&tooMuchPaid&minAmountPaid&toDatePayment&minAmountBilled&toDateBilling&maxWaterConsumption&toDateWaterConsumption&filterBalanceWithService',
            data: {
                authorities: ['ROLE_READ_ONLY'],
                pageTitle: 'wamasysApp.reportingAgence.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/reporting-payment-arrears/reporting-payment-arrears.html',
                    controller: 'ReportingPaymentArrearsController',
                    controllerAs: 'vm'
                }
            },

            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                	$translatePartialLoader.addPart('reportingGlobal');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('contrat');
                    $translatePartialLoader.addPart('etatContrat');
                    return $translate.refresh();
                }]
            }
        });
    }

})();
